import React, { useState } from "react";
import Modal from "../../../shared/components/Modal/Modal";
import "./GameficationMode.css";
import images from "../../../utilities/images/images";

function GameficationMode({
  isOpen,
  onClose,
  onConfirm,
  attemptMessage,
  testName,
}) {
  const [gamificationOn, setGamificationOn] = useState(false);
  const [selectedMode, setSelectedMode] = useState(null);
const isTestModeDisabled = !!attemptMessage;
  // const handleContinue = () => {
  //   if (!selectedMode) return;
  //   onConfirm({ selectedMode, gamificationOn });
  // };
  const handleTestMode = () => {
     if (attemptMessage) return;
    onConfirm({
      selectedMode: "test",
      gamificationOn: false,
    });
  };
  const handlePracticeMode = () => {
    setSelectedMode("practice"); 
    onConfirm({
      selectedMode: "practice",
      gamificationOn,
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="35rem" height="26.5rem">
     
      <div className="gm-wrapper">
        <h2 className="gm-title">{testName?.trim() ? testName.trim() : "Practice test"}</h2>
      <p className="gm-subtitle">Choose Your Practice Mode</p>

        <div className="gm-card gm-toggle">
          <div className="gm-left">
            <span className="gm-fire"><img src={images.streakfire_icon} alt="fire" /></span>
            <div>
              <h4>Gamification Mode</h4>
              <p>Enable gamification & streaks with instant feedback.</p>
            </div>
          </div>

          <label className="switch">
            <input
              type="checkbox"
              checked={gamificationOn}
                // onChange={() => setGamificationOn(prev => !prev)}
              onChange={() => {
                setGamificationOn(prev => {
                  const next = !prev;

                  if (next) {
                    setSelectedMode("practice"); 
                  }

                  return next;
                });
              }}
              
            />

            <span className="gm-slider" />
          </label>
        </div>

        <div
          className={`gm-card ${selectedMode === "test" ? "gm-selected" : ""}`}
          // onClick={() => {
          //   setSelectedMode("test");
          //   setGamificationOn(false); 
          // }}
          onClick={handleTestMode}
style={{
    opacity: isTestModeDisabled ? 0.5 : 1,
    pointerEvents: isTestModeDisabled ? "none" : "auto",
    cursor: isTestModeDisabled ? "not-allowed" : "pointer",
  }}
        >

          <div className="gm-left">
            <div className="gm-icon test"><img src={images.streaktest} alt="calender" /></div>
            <div>
              <h4>Test Mode</h4>
              <p>Timed test simulation (3 hours) with final results</p>
              {attemptMessage && (
  <p style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
    {attemptMessage}
  </p>
)}
            </div>
          </div>
        </div>

        <div
        className={`gm-card ${gamificationOn ? "gm-gamified" : ""}`}
          // className={`gm-card ${selectedMode === "practice" ? "gm-selected" : ""
          //   } ${selectedMode === "practice" && gamificationOn ? "gm-gamified" : ""
          //   }`}
          // onClick={() => setSelectedMode("practice")}
          onClick={handlePracticeMode}

        >
          <div className="gm-left">
            <div className="gm-icon practice"><img src={images.streakpractice} alt="" /></div>
            <div>
              <h4>Practice Mode</h4>
              <p>Untimed practice with solutions & explanations</p>
              {selectedMode === "practice" && gamificationOn && (
                <div className="gm-feedback">  <img src={images.streaktick} alt="tick" className="tick-icon" /> Immediate feedback</div>
              )}
            </div>
          </div>

          {/* {selectedMode === "practice" && gamificationOn && ( */}
          {gamificationOn && (
            <div className="gm-badge"><img src={images.streakfire_icon} alt="fire" className="fire-icon" />Streak Mode Activated</div>
          )}
        </div>

        {/* <button
          className="start_test_btn"
          disabled={!selectedMode}
          onClick={handleContinue}
        >
          Continue
        </button> */}
      </div>
    </Modal>
  );
}

export default GameficationMode;
